import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from "@angular/forms";
//import { FormBuilder, FormGroup, FormControl, Validators } from "@angular/forms";
import { FahrscheinService } from '../../_service/fahrschein.service';
import { FahrtService } from '../../_service/fahrt.service';
import { BlockService } from '../../_service/block.service';
import { PartnerService } from '../../_service/partner.service';
import { WochentagService } from '../../_service/wochentag.service';
import { FahrscheinModel } from '../../_model/FahrscheinModel';
import { FahrtModel } from '../../_model/FahrtModel';
import { BlockModel } from '../../_model/BlockModel';
import { first } from "rxjs/operators";
import { Router } from "@angular/router";

@Component({
  selector: 'app-fahrschein-edit',
  templateUrl: './fahrschein-edit.component.html',
  styleUrls: ['./fahrschein-edit.component.css']
})
export class FahrscheinEditComponent implements OnInit {

  editForm: FormGroup;
  fahrten: FahrtModel[];
  fahrten_display: FahrtModel[];
  blocks: BlockModel[];
  wochentage: {id: Number, name: String} [];

  constructor(private formBuilder: FormBuilder, private router: Router, private fahrtService: FahrtService,private fahrscheinService: FahrscheinService,private blockService: BlockService, private partnerService: PartnerService, private wochentagService: WochentagService) { }

  
  // form read only components
  mySollSumme: Number
  message: any;
  success_message: any;
  myWochentag: any
  
  submitted = false;

  ngOnInit() {
    let fahrscheinId = 0
    let fahrscheinIdStr = localStorage.getItem("fahrscheinId");
    if(!fahrscheinIdStr){
      alert("Something wrong!");
      this.router.navigate(['fahrschein-list']);
      return;
    } else {
      fahrscheinId = parseInt(fahrscheinIdStr);
    } 
  
    this.wochentage = this.wochentagService.getAllWochentage();

    this.getAllFahrten();
    this.getAllBlocks();

    var jetzt = new Date().toISOString().split('T')[0];
    var tagNr = this.berechneWochentag(jetzt);
    var wochentag = this.wochentage[tagNr].name.substring(0,3)
    
    this.editForm = this.formBuilder.group({
      id: [],
      fahrtId: ['', Validators.required],
      gastName: [''],
      datum: [jetzt, Validators.required],
      personen: ['0', Validators.required],
      kinder: ['0', Validators.required],
      sonstigesPreis: ['0',Validators.pattern(/^-?\d+(,|\.|d)?\d*$/)],
      sonstigesText: [''],
      summe: ['',[Validators.pattern(/^-?\d+(,|\.|d)?\d*$/),Validators.required]],
      wochentag: [wochentag],
      blockId: [null],
      Partnername: [''],
      SollSumme: [this.mySollSumme]
    });
    this.fahrscheinService.getFahrscheinById(fahrscheinId).subscribe(data=>{
      console.log(data);
      this.editForm.patchValue(data); //Don't use editForm.setValue() as it will throw console error
      this.calcFieldChanged();
    });

  }
  cancelEdit(){
    this.router.navigate(['fahrschein-list']);
  }

  getAllFahrten(): void {
    this.fahrtService.getAllFahrten().subscribe(data=>{
      this.fahrten = data;
      this.fahrten = this.fahrten.sort((n1,n2) => Number(n1.fahrtnummer) - Number(n2.fahrtnummer));
      this.fahrten_display = this.fahrten ;
    });
  };
  getAllBlocks(): void {
    this.blockService.getAllBlocks().subscribe(data=>{
      this.blocks = data;
    });
  };

  datumChanged(e: any) {
      console.log (this.editForm.value.datum)
      this.message = null
      var tagNr = this.berechneWochentag(this.editForm.value.datum)  // 0 = kein 1=Mon 7=Son vgl. wochentag.service 
      console.log(tagNr)
      this.editForm.patchValue({wochentag: this.wochentage[tagNr].name.substring(0,3)});
      this.fahrten_display = this.fahrten.filter(fahrt => (Number(fahrt.wochentag) == tagNr || Number(fahrt.wochentag) == 0))
      if (this.fahrten_display.length == 0) {
        this.message = "keine Fahrt an "+this.wochentage[tagNr].name
      }
  }
  berechneWochentag(inDatumString) {
    var jetzt = new Date(inDatumString)
    var tag = jetzt.getDate()
    var tagZahl = jetzt.getDay()
        if (tagZahl == 0 ) tagZahl = 7
    return tagZahl	
  } 
  calcFieldChanged() {
      console.log ("in Change")
      var anzPers = this.editForm.value.personen
      var anzKind = this.editForm.value.kinder
      var eurSonst = this.editForm.value.sonstigesPreis
      var fahrtId = this.editForm.value.fahrtId
      var fahrt = this.fahrten.find(f => f.id == fahrtId)
      if (fahrt != null) {
          this.mySollSumme = Number(fahrt.preisPerson) * anzPers + Number(fahrt.preisKind) * anzKind + Number(eurSonst)
//          console.log (this.mySollSumme)
          this.editForm.patchValue({SollSumme: this.mySollSumme})
      }
  }

  onSubmit(){
    this.submitted = true;
    
    if(this.editForm.valid){
      this.fahrscheinService.updateFahrschein(this.editForm.value)
      .subscribe( data => {
        console.log(data);
        this.router.navigate(['fahrschein-list']);
      });
    }
  }

  // get the form short name to access the form fields
  get f() { return this.editForm.controls; }

}
